import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-cloudbased-solutions',
    templateUrl: './custom-cloudbased-solutions.component.html',
    styleUrls: ['./custom-cloudbased-solutions.component.scss'],
    standalone: false
})
export class CustomCloudbasedSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
